module.exports = __webpack_public_path__ + "img/E0A8.1f5c115f.svg";